import Modal from "bootstrap/js/dist/modal";
import bootstrapModalController from "./controller.js";

export default bootstrapModalController(Modal);
